"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateEffect = void 0;
var react_1 = require("react");
var __1 = require("..");
var const_1 = require("../util/const");
/**
 * Effect hook that ignores the first render (not invoked on mount).
 *
 * @param effect Effector to run on updates
 * @param deps Dependencies list, as for `useEffect` hook
 */
function useUpdateEffect(effect, deps) {
    var isFirstMount = (0, __1.useFirstMountState)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(isFirstMount ? const_1.noop : effect, deps);
}
exports.useUpdateEffect = useUpdateEffect;
